import React from 'react';

import { req, useApiLoading } from 'react-reqq-lite';
import Cookie from 'js-cookie';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';

import LogoFaded from 'modules/partial/components/LogoFaded';
import Logo from 'assets/images/logo.svg';
import { Button } from 'modules/common/input';
import { replaceAllString, storage } from 'modules/common/utils';
import { toastSuccess } from 'modules/common/toast';

import { AUTHENTICATION } from '../constants';

function RegisterLoader() {
  const history = useHistory();
  const location = useLocation();
  const isApiLoading = useApiLoading('RESEND_EMAIL_VERIFICATION', 'post');
  const query = qs.parse(location?.search) || {};
  const token = query?.token;
  const confirmed = query?.confirmed;
  const reset_password = +query?.reset_password || 0;
  const message = query?.message ? replaceAllString(query?.message, '"') : '';

  const handleOnResendEmailVerification = React.useCallback(
    (e) => {
      const email = location?.search.split('&')[2];

      e.preventDefault();
      req.post({
        key: 'RESEND_EMAIL_VERIFICATION',
        url: '/v1/vendors/registration/resend-verify-email',
        payload: {
          email_address: email.split('=')[1],
        },
        onSuccess: () => {
          toastSuccess('Please check your email to verify your PEP account');
          history.push('/merchant-login');
        },
      });
    },
    [history, location?.search]
  );

  React.useEffect(() => {
    Cookie.remove('_tutorial_step');
    Cookie.remove('_show_tutorial');
    Cookie.remove('_token');
    Cookie.remove('_userType');
    Cookie.remove('_subscription');
  }, []);

  React.useEffect(() => {
    if (confirmed === 'true' && token) {
      setTimeout(
        () => {
          req.set(AUTHENTICATION, {
            isAuthenticated: !!token,
            type: 'MERCHANT',
          });
          Cookie.set('_token', token);
          Cookie.set('_userType', 'MERCHANT');
          if (!reset_password) {
            Cookie.set('_tutorial_step', 1);
            Cookie.set('_show_tutorial', 1);
            history.push('/onboarding');
            return;
          }
          storage.set('reset_password', 1);
          history.push('/onboarding-set-password');
        },
        reset_password ? 5000 : 4000
      );
    }
  }, [confirmed, history, reset_password, token]);

  const renderContent = React.useMemo(() => {
    if (confirmed === 'true' && token) {
      return (
        <>
          <div className="font-semibold text-2xl">
            {!reset_password ? (
              <span>Merchant registration successful.</span>
            ) : (
              <div>
                <div>Validating your merchant account.</div>
                <div>Please wait...</div>
              </div>
            )}
          </div>
          <div className="text-gray-500 text-sm animate-pulse">
            REDIRECTING...
          </div>
        </>
      );
    }

    if (
      confirmed === 'false' &&
      message === 'Email Address already verified' &&
      !token
    ) {
      return (
        <>
          <div className="font-semibold text-2xl">
            Email is already verified.
          </div>
          <Button
            className="btn md primary font-medium px-6"
            label="Login to your account"
            to="/merchant-login"
          />
        </>
      );
    }

    return (
      <>
        <div className="font-semibold text-2xl">
          Email verification link has expired.
        </div>
        <Button
          className="btn md primary"
          label="Resend Verification Link"
          disabled={isApiLoading}
          onClick={handleOnResendEmailVerification}
        />
      </>
    );
  }, [
    token,
    message,
    confirmed,
    isApiLoading,
    reset_password,
    handleOnResendEmailVerification,
  ]);

  return (
    <>
      <LogoFaded />
      <div className="fixed z-50 inset-0 h-screen w-screen bg-white">
        <div className="h-screen flex">
          <div className="m-auto space-y-8 flex flex-col">
            <img src={Logo} className="h-[200px]" alt="logo" />
            <div className="space-y-6 text-center">{renderContent}</div>
          </div>
        </div>
      </div>
    </>
  );
}

RegisterLoader.propTypes = {};

export default RegisterLoader;
